import * as React from 'react';
import { Component } from '../../../../../../infrastructure/type-extensions';
import { CommonPopoverContext } from '../../../../../global/common-popover/common-popover.context';
import { CommonPopover } from '../../../../../global/common-popover/common-popover';
import { DefaultClosePopoverButton } from '../../../../../global/common-popover/default-close-popover-button';
import { FormViewModelController } from '../../../../../../infrastructure/form-viewmodel-controller';
import { LinkForm } from './link-form/link-form';
import { LinkFormViewModel } from './link-form/link-form.viewmodel';
import { addText, cancelText } from '../../../../../../constants/common-labels.constants';

interface IFormContainerDerivedProps {
    isOpen: boolean;
    formVM: FormViewModelController;
}
export const makeLinkFormInPopover = <T extends IFormContainerDerivedProps>(PopoverTriggerComponent: Component<T>) => {
    // we need to utilize context.consumer in order to identify 'isOpen' value, but usage of popover forcing ref forwarding
    // therefore utilize React.forwardRef to create HOC over the PopoverTriggerComponent, which would utilize context and forward ref
    const ComponentWithForwardedRef = React.forwardRef<HTMLElement, T>((props: T, ref: React.Ref<HTMLElement>) => {
        return (
            <CommonPopoverContext.Consumer>
                {context => <PopoverTriggerComponent {...props} isOpen={context.isOpen} ref={ref} />}
            </CommonPopoverContext.Consumer>
        );
    });
    // T can not be casted to ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>
    // can't get the reason for this, but for now just cast targetComponentProps to any while passing to component with forwarded ref
    // tslint:disable:no-any
    return props => {
        const formVM = LinkFormViewModel.create(props.formProps);

        const onApply = (): void | null => {
            if (!formVM.isVmValid()) {
                formVM.setVmTouched();
                return null;
            }

            props.onApply(formVM.getFormFields());
        };

        return (
            <CommonPopover
                className='oe-popup-layout__body--fixed-width event-link-form-in-popover'
                body={<LinkForm vm={formVM} />}
                footer={
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultClosePopoverButton
                            text={addText()}
                            modifier={['fat', 'confirm-safe']}
                            onClick={onApply}
                        />
                        <DefaultClosePopoverButton
                            text={cancelText()}
                            onClick={props.onCancel}
                        />
                    </div>
                }
                position='left'
                align='start'
                onClose={formVM.reset}
            >
                <ComponentWithForwardedRef {...props } />
            </CommonPopover>
            // tslint:enable:no-any
        );
    };
};
